import { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import * as serviceWorker from './utils/serviceWorker';
import { store } from 'redux/store';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { Amplify } from 'aws-amplify';
import 'utils/i18n';
import 'normalize.css';
import 'styles/custom-bootstrap.scss';
import 'styles/index.css';
import Authenticator from 'pages/Authenticator';
import Loading from 'pages/LayoutContainer/Loading';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_AMPLIFY_AUTH_USER_POOL_ID as string,
      userPoolClientId: process.env
        .REACT_APP_AMPLIFY_AUTH_USER_POOL_WEB_CLIENT_ID as string,
    },
  },
});

process.env.REACT_APP_ENABLE_CONSOLE_LOG !== 'true' &&
  (console.log = () => {
    // 空関数を渡すため記載なし
  });

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="*" element={<Authenticator />} />
        </Routes>
        <Loading />
      </Suspense>
    </BrowserRouter>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
